import { Navigate, Outlet } from 'react-router-dom';

import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import { useMatchCurrentPage } from '@/hooks/useMatchCurrentPage';
import { usePathSet } from '@/hooks/usePathSet';
import { useUIStyle } from '@/hooks/useUIStyle';

export const ConservationProtection = () => {
  const pathSet = usePathSet();
  const isConservationRequiredPage = useMatchCurrentPage([pathSet.mediaUpload, pathSet.mediaUploadPlotOverview]);

  const hasConservationUIStyle = useUIStyle(OrganizationUIStyle.CONSERVATION);

  if (isConservationRequiredPage && !hasConservationUIStyle) {
    return <Navigate to={pathSet.dashboard} replace />;
  }

  return <Outlet />;
};
